// extracted by mini-css-extract-plugin
export default {"phoneInput":"CustomPhoneInput_phoneInput__jidHL","phoneInput_input":"CustomPhoneInput_phoneInput_input__f+LKJ","disabled":"CustomPhoneInput_disabled__Folbr"};